/**
 * The page content scrolls inside <main>, not the window, so `window.scrollTo` moves nothing.
 * Scroll that element instead, falling back to the window when it is absent (auth pages render
 * outside the layout).
 */
export const PAGE_SCROLL_ID = 'page-scroll'

export function scrollPageToTop(behavior: ScrollBehavior = 'smooth') {
  const el = document.getElementById(PAGE_SCROLL_ID)
  if (el) {
    el.scrollTo({ top: 0, behavior })
    return
  }
  window.scrollTo({ top: 0, behavior })
}
